import React from 'react'
import { Stack } from '@chakra-ui/react'

export default (props) => {
  return <Stack {...props} gap={props.gap ?? props.spacing} />
}

export function ResponsiveStack (props) {
  return <Stack {...props} direction={{ base: 'column', md: 'row' }} />
}
